import { BackButton } from 'atoms/BackButton';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { AppFooter } from 'templates/AppFooter';

import { PageContent } from 'templates/PageContent';
import { UnauthHeader } from 'templates/UnauthHeader';

export function LoginError() {
  const { t: tLoginError } = useTranslationWithLang('loginError');
  return (
    <>
      {/*
       * TODO:文章は仮置きしたものなので修正が必要
       * TODO:i18nextに対応する
       */}
      <div className="h-full" style={{ background: 'var(--c-background)' }}>
        <UnauthHeader />
        <div role="heading" aria-level={1} aria-live="assertive" className="sr-only">
          {tLoginError('TU000_001')}
        </div>
        <PageContent>
          <h1 className="text-[--c-text2] font-bold text-2xl mb-8 underline">
            {tLoginError('TU000_001')}
          </h1>

          <h2 className="font-semibold">1. {tLoginError('TU000_002')}</h2>
          <ul className="list-disc ml-5 mb-4">
            <li>{tLoginError('TU000_003')}</li>
            <li>{tLoginError('TU000_004')}</li>
            <li>{tLoginError('TU000_005')}</li>
            <li>{tLoginError('TU000_006')}</li>
          </ul>

          <h2 className="font-semibold">2. {tLoginError('TU000_007')}</h2>
          <p className="mb-2">{tLoginError('TU000_008')}</p>

          <h2 className="font-semibold">3. {tLoginError('TU000_009')}</h2>
          <p className="mb-2">{tLoginError('TU000_010')}</p>
          <ul className="list-disc ml-5 mb-4">
            <li>Microsoft Edge</li>
            <li>Google Chrome</li>
            <li>Safari</li>
          </ul>
          <p className="italic">※{tLoginError('TU000_011')}</p>

          <h2 className="font-semibold mt-4">4. {tLoginError('TU000_012')}</h2>
          <p className="mb-2">{tLoginError('TU000_013')}</p>

          <h2 className="font-semibold">{tLoginError('TU000_014')}</h2>
          <p className="mb-2">{tLoginError('TU000_015')}</p>
          <p className="mb-4">{tLoginError('TU000_016')}</p>
          <div className="flex justify-center">
            <BackButton />
          </div>
        </PageContent>
        <AppFooter />
      </div>
    </>
  );
}
